export default __webpack_public_path__ + "static/media/matches.36f77cf4.svg";